var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col w-full p-4 my-4 mb-0 rounded",class:_vm.bodyClass},[_c('h4',{staticClass:"font-semibold",class:_vm.headingClass,domProps:{"textContent":_vm._s(_vm.heading)}}),_c('p',[_vm._v(_vm._s(_vm.bodyText))])])}
var staticRenderFns = []

export { render, staticRenderFns }